import {
  Card,
  CardContent,
  Grid,
  Icon,
  Link,
  Typography,
  Button,
  useMediaQuery,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import classnames from 'classnames';
import { makeStyles } from '@mui/styles';
import React from 'react';
import styles from './style';
import { LobIcon } from '../../misc';
import { useSmall } from '../../../hooks';
import { Spinner } from '../../common';

const useStyles = makeStyles(styles);

function CategoryCard(props) {
  const { product, isAction, loading } = props;
  const { materialIcon, icon, customIcon, title, subTitle, onClick, href, lob } = product;
  // console.log('product: ', product);
  const isSmall = useSmall();

  const classes = useStyles({ ...props, isSmall });
  // console.log('Href in the product category card ', href);
  return (
    <Card
      className={classnames(
        classes.cardContainer,
        { [classes.lobHover]: !isAction },
        {
          [classes.actionHover]: isAction,
        },
      )}
      sx={{ boxShadow: 3 }}
      variant="outlined"
    >
      <Button
        component={RouterLink}
        to={href}
        className={classes.cardButton}
        onClick={onClick}
      >
        <Grid container>
          <Grid item xs={12} md={isAction ? 4 : 12} align="center">
            <LobIcon
              customIcon={customIcon}
              lob={lob}
              materialIcon={materialIcon}
              icon={icon}
              className={classes.iconContainer}
            />
          </Grid>
          <Grid xs={12} md={isAction ? 8 : 12} item className={classes.textContainer}>
            {title && <Typography className={classes.titleStyles}>{title}</Typography>}
            {subTitle && (
              <>
                {loading ? (
                  <Spinner />
                ) : (
                  <Typography className={classes.subTitleStyles}>{subTitle}</Typography>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Button>
    </Card>
  );
}

export default CategoryCard;
